export default function ($container, itemClass, onDragEnd) {
    $container.each(function () {
        this.addEventListener('dragstart', evt => {
            evt.target.classList.add(`selected`);
            evt.target.parentElement.classList.add(`dragging`);
            evt.dataTransfer.setData('text/html', null); //cannot be empty string
        });

        this.addEventListener(`dragend`, evt => {
            evt.preventDefault();
            evt.target.classList.remove(`selected`);
            evt.target.parentElement.classList.remove(`dragging`);
            onDragEnd(evt.target)
        });

        this.addEventListener(`dragover`, evt => {
            evt.preventDefault();
            const activeElement = this.querySelector(`.selected`);
            const currentElement = evt.target;
            const isMoveable = activeElement !== currentElement &&
                currentElement.classList.contains(itemClass);

            if (!isMoveable) {
                return;
            }

            const nextElement = getNextElement(evt.clientY, currentElement);
            if (!nextElement) {
                this.appendChild(activeElement);
            } else if (
                activeElement === nextElement.previousElementSibling ||
                activeElement === nextElement
            ) {
                return;
            }

            this.insertBefore(activeElement, nextElement);
        });
    })

    const getNextElement = (cursorPosition, currentElement) => {
        const currentElementCoord = currentElement.getBoundingClientRect();
        const currentElementCenter = currentElementCoord.y + currentElementCoord.height / 2;

        return (cursorPosition < currentElementCenter)
            ? currentElement
            : currentElement.nextElementSibling;
    }
}
